<!--<app-spinner></app-spinner>-->
<h1 class="text-center auth-heading">
  <img src="assets/layout/images/wtg-logo-transparent-white.webp" alt="wtg watch this garage logo" class="app-logo">
  <small>{{ 'auth.change_owner.title' | translate }}</small>
</h1>
<p class="text-justify">{{ 'auth.change_owner.description' | translate }}</p>
<div class="col-12 flex justify-content-center">
  <div>
    <p-inputOtp [length]="6" (onChange)="submit()" [(ngModel)]="pin"></p-inputOtp>
  </div>
</div>
